import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";
import { Plus, Pencil, CircleX, ArrowLeft, BookImage, CircleHelp } from "lucide-react";
import { Link } from "react-router-dom";

export default function Obras() {
   const [obras, setObras] = useState([]);
   const [tasks, setTasks] = useState([]);
   const [estados, setEstados] = useState([]);
   const [imagenes, setImagenes] = useState([]);
   const [change, setChange] = useState(false);
   const [imageindx, setImageIndex] = useState(0);
   const [selected, setSelected] = useState([]);
   const [currentFilter, setCurrentFilter] = useState(""); // Para el select simple
   const [selectedCod, setSelectedCod] = useState("");
   const [editRecord, setEditRecord] = useState(null);
   const [imageRecord, setImageRecord] = useState(null);

   const fetchTabla = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 2)
         .gt("orden", 1)
         .order("descripcion", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };

   const fetchEstados = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 1)
         .gt("orden", 1)
         .order("descripcion", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setEstados(data);
   };


   const fetchObras = async () => {
      const { error, data } = await supabase
         .from("obras")
         .select(`*,
            tabla (id,descripcion)`)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading obra: ", error.message);
         return;
      }

      setObras(data);
   };
   const fetchImagenes = async (id) => {
      const { error, data } = await supabase
         .from("imagenes")
         .select("*")
         .eq("obra_id", id)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading imagenes: ", error.message);
         return;
      }

      console.log("fetchImagenes: ", data);
      setImagenes(data);
   };

   useEffect(() => {
      fetchTabla();
      fetchEstados();
      fetchObras();
   }, [change]);


   
   
   // Función modificada para agregar filtro automáticamente
   const handleFilterChange = (e) => {
      const selectedValue = e.target.value;
      if (selectedValue && !selected.includes(selectedValue)) {
         setSelected([...selected, selectedValue]);
      }
      setCurrentFilter(""); // Limpiar el select inmediatamente
   };
   
   const filters = obras.filter((item) => item.orden === 1);
   // console.log("filters: ", filters);

   const filteredRecords = selectedCod
      ? obras.filter(
           (item) => item.cod === Number(selectedCod) && item.orden > 1
        )
      : [];

   const maxOrden = Math.max(
      ...filteredRecords
         .filter((item) => item.cod === Number(selectedCod))
         .map((item) => item.orden)
   );

   // const handleFileChange = (e) => {
   //    if (e.target.files && e.target.files.length > 0) {
   //       setTaskImage(e.target.files[0]);
   //    }
   //    console.log("e.target.files: ", e.target.files[0]);
   // };

   const handleSave = async () => {
      console.log("maxOrden: ", maxOrden);
      console.log("editRecord: ", editRecord);
      console.log('selected: ', selected);
      if (!editRecord.id) {
         const finalData = { ...editRecord, estado: 2,
            filtros: JSON.stringify(selected)
          };
         const { error } = await supabase.from("obras").insert(finalData);
         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      } else {
         const { error } = await supabase
            .from("obras")
            .update({
               titulo: editRecord.titulo,
               descripcion: editRecord.descripcion,
               medidas: editRecord.medidas,
               filtros: JSON.stringify(selected),
               precio: editRecord.precio,
               estado: editRecord.estado
            })
            .eq("id", editRecord.id);

         if (error) {
            console.log("error ", error);
            alert(error.message);
            return;
         }
         setChange(!change);
      }
      setEditRecord(null);
   };

   const handleImages = async (id) => {
      await fetchImagenes(id);
      console.log("handleImages: ", id, imagenes);
      setImageRecord(imagenes);
   };
   const handleDelete = async (id) => {
      const { error } = await supabase.from("obras").delete().eq("id", id);

      if (error) {
         console.log("error ", error);
         alert(error.message);
         return;
      }
      setChange(!change);
   };
   const changeImage = (accion) => {
      console.log("changeImage: ", accion);
      if (accion === "+") {
         setImageIndex(imageindx + 1);
      } else {
         setImageIndex(imageindx - 1);
      }
      console.log("changeImage imageindx: ", imageRecord[imageindx]?.texto);
      setChange(!change);
   };

   const handleChange = (e) => {
      const values = Array.from(e.target.selectedOptions, (opt) => opt.value);
      setSelected(values);
   };

   // Nueva función para agregar filtro individual
   const addFilter = () => {
      if (currentFilter && !selected.includes(currentFilter)) {
         setSelected([...selected, currentFilter]);
         setCurrentFilter(""); // Limpiar el select
      }
   };

   // Función para remover filtro
   const removeFilter = (filterId) => {
      setSelected(selected.filter(id => id !== filterId));
   };

   // Filtrar tasks que ya están seleccionados
   const availableTasks = tasks.filter(task => !selected.includes(String(task.id)));


   // console.log("obras: ", obras);
   // console.log("imageRecord: ", imageRecord[imageindx].texto);
  return (
      <div className="max-w-xl mx-auto">
         {/* Results Table */}
         <div className="mt-6">
            <div className="flex justify-between items-center">
               <div className="flex items-center gap-2 mb-3">
                  <h2 className="text-lg font-semibold">OBRAS:</h2>
                  <Link
                     to="/admcuru/obrashelp"
                     className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100"
                     title="Ir a ayuda"
                     aria-label="Ir a ayuda"
                     target="_blank"
                  >
                     <CircleHelp size={16} />
                  </Link>
               </div>
               <button
                  onClick={() => {
                     setEditRecord({});
                     setSelected([]);
                     setCurrentFilter("");
                  }}
                  className="btn-green pl-1 pr-1 md:pl-4 md:pr-4  text-xs md:text-xs"
               >
                  <Plus className="lucid-icons-blue" /> Nuevo
               </button>
            </div>
            {obras.length > 0 && (
               <table className="w-full border border-gray-300 rounded-lg overflow-hidden">
                  <thead className="bg-gray-200 text-gray-700">
                     <tr>
                        <th className="p-2 text-left hidden md:table-cell">ID</th>
                        <th className="p-2 text-left">Titulo</th>
                        <th className="p-2 text-left">Estado</th>
                        <th className="p-2 text-left">Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {obras.map((rec) => (
                        <tr key={rec.id} className="border-t hover:bg-gray-50">
                           <td className="p-2 hidden md:table-cell">{rec.id}</td>
                           <td className="p-2">{rec.titulo}</td>
                           <td className="p-2">{rec.tabla.descripcion}</td>
                           <td className="p-2 flex gap-2">
                              <button
                                 onClick={() => {
                                    setEditRecord({ ...rec });
                                    setCurrentFilter("");
                                    // Parse filtros and set selected values
                                    if (rec.filtros) {
                                       try {
                                          const filtrosArray = JSON.parse(rec.filtros);
                                          setSelected(filtrosArray.map(String));
                                       } catch (error) {
                                          // If filtros is not valid JSON, try to extract IDs manually
                                          const matches = rec.filtros.match(/"(\d+)"/g);
                                          if (matches) {
                                             const ids = matches.map((match) =>
                                                match.replace(/"/g, "")
                                             );
                                             setSelected(ids);
                                          } else {
                                             setSelected([]);
                                          }
                                       }
                                    } else {
                                       setSelected([]);
                                    }
                                 }}
                                 className="btn-green pl-1 pr-1 md:pl-4 md:pr-4 text-xs md:text-xs"
                              >
                                 <Pencil className="lucid-icons-blue" /> Editar
                              </button>
                              <button
                                 onClick={() => handleDelete(rec.id)}
                                 className="btn-red pl-1 pr-1 md:pl-4 md:pr-4 text-xs md:text-xs"
                              >
                                 <CircleX className="lucid-icons-red" /> Borrar
                              </button>
                              <Link
                                 to="/admcuru/imagenes"
                                 className="btn-purple pl-1 pr-1 md:pl-4 md:pr-4 text-xs md:text-xs"
                                 state={{
                                    rec: rec,
                                 }}
                              >
                                 <BookImage className="lucid-icons-blue" /> Imagenes
                              </Link>
                           </td>
                        </tr>
                     ))}
                  </tbody>
               </table>
            )}
         </div>

         {/* Modal */}
         {editRecord && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
               <div className="bg-white p-6 rounded-lg shadow-lg w-2/4">
                  <h2 className="text-xl font-bold mb-4">
                     {editRecord.id ? "Editar Registro" : "Nuevo Registro"}
                  </h2>
                  
                  {/* Titulo */}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Titulo
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.titulo || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              titulo: e.target.value,
                           })
                        }
                     />
                  </div>

                  {/* Descripción */}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Descripción
                     </label>
                     <textarea
                        rows={5}
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.descripcion || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              descripcion: e.target.value,
                           })
                        }
                     />
                  </div>

                  {/* Medidas */}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Medidas de la Imagen
                     </label>
                     <input
                        type="text"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.medidas || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              medidas: e.target.value,
                           })
                        }
                     />
                  </div>

                  {/* Filtros - Select Simple */}
                  <div className="flex pb-4 items-start">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Clasificación de la Obra
                     </label>
                     <div className="w-full">
                        {/* Select sin botón */}
                        <div className="mb-3">
                           <select
                              value={currentFilter}
                              onChange={handleFilterChange}
                              className="w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                           >
                              <option value="">Seleccione un filtro para agregar...</option>
                              {availableTasks.map((item) => (
                                 <option key={item.id} value={item.id}>
                                    {item.descripcion}
                                 </option>
                              ))}
                           </select>
                        </div>

                        {/* Filtros Selected Display */}
                        <div className="p-3 bg-gray-50 rounded-lg border">
                           <h4 className="text-sm font-semibold text-gray-700 mb-2">
                              Filtros Seleccionados:
                           </h4>
                           {selected.length > 0 ? (
                              <div className="flex flex-wrap gap-2">
                                 {selected.map((filterId) => {
                                    const task = tasks.find(
                                       (t) => String(t.id) === String(filterId)
                                    );
                                    return task ? (
                                       <div
                                          key={filterId}
                                          className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200"
                                       >
                                          <span className="mr-1">✅</span>
                                          {task.descripcion}
                                          <button
                                             type="button"
                                             onClick={() => removeFilter(filterId)}
                                             className="ml-2 text-green-600 hover:text-green-800 focus:outline-none hover:bg-green-200 rounded-full w-4 h-4 flex items-center justify-center transition-colors"
                                             title="Remover filtro"
                                          >
                                             ×
                                          </button>
                                       </div>
                                    ) : null;
                                 })}
                              </div>
                           ) : (
                              <p className="text-sm text-gray-500 italic">
                                 No hay filtros seleccionados
                              </p>
                           )}
                           <div className="mt-2 text-xs text-gray-500">
                              Total: {selected.length} filtro{selected.length !== 1 ? 's' : ''} seleccionado{selected.length !== 1 ? 's' : ''}
                           </div>
                        </div>

                        {/* Botones de acción rápida */}
                        <div className="mt-3 flex gap-2">
                           <button
                              type="button"
                              onClick={() => {
                                 setSelected([]);
                                 setCurrentFilter("");
                              }}
                              className="px-3 py-1 text-xs bg-red-200 text-red-700 rounded hover:bg-red-300 transition-colors"
                              disabled={selected.length === 0}
                           >
                              🗑️ Limpiar Todo
                           </button>
                           <button
                              type="button"
                              onClick={() => {
                                 setSelected(tasks.map(t => String(t.id)));
                                 setCurrentFilter("");
                              }}
                              className="px-3 py-1 text-xs bg-green-200 text-green-700 rounded hover:bg-green-300 transition-colors"
                              disabled={selected.length === tasks.length}
                           >
                              ✅ Seleccionar Todo
                           </button>
                        </div>
                     </div>
                  </div>

                  {/* Precio */}
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Precio U$S
                     </label>
                     <input
                        type="number"
                        className="w-full p-2 border rounded mb-4"
                        value={editRecord.precio || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              precio: e.target.value,
                           })
                        }
                     />
                  </div>
                  <div className="flex justify-between items-center">
                     <label className="block mb-2 text-sm font-medium text-gray-700 p-2 w-48">
                        Estado
                     </label>
                     <select
                        value={editRecord.estado}
                        // onChange={(e) => onChange(e.target.value)}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              estado: e.target.value,
                           })
                        }
                        className="block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm 
                                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
                                 sm:text-sm"
                     >
                        <option value="">Seleccione...</option>
                        {estados.map((item) => (
                        <option key={item.id} value={item.id}>
                           {item.descripcion}
                        </option>
                        ))}
                     </select>                     
                  </div>                  

                  {/* Botones */}
                  <div className="flex justify-end gap-3">
                     <button
                        onClick={() => {
                           setEditRecord(null);
                           setSelected([]);
                           setCurrentFilter("");
                        }}
                        className="btn-gray-light"
                     >
                        <ArrowLeft className="lucid-icons" /> Volver
                     </button>
                     <button onClick={handleSave} className="btn-green">
                        <Plus className="lucid-icons-blue" /> Guardar
                     </button>
                  </div>
               </div>
            </div>
         )}
      </div>
   );
}